<template>
  <div class="home-menu">
    <!-- 見積書管理 -->
    <div v-if="showEstimateMenu" class="workflow-section bg-estimate-work">
      <h2>見積書管理</h2>
      <div class="estimate-menu-grid">
        <div class="estimate-menu-item">
          <h3>見積書を確認・管理</h3>
          <router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'EstimateList' }">見積書一覧</router-link>
        </div>
        <div v-if="canCreateEstimate" class="estimate-menu-item">
          <h3>縦型の見積書を作成</h3>
          <router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'EstimateCreate', query: { layout: 'portrait_temporary' } }">新規作成（縦型）</router-link>
        </div>
        <div v-if="canCreateEstimate" class="estimate-menu-item">
          <h3>横型の見積書を作成</h3>
          <router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'EstimateCreate', query: { layout: 'landscape_detailed' } }">新規作成（横型・詳細）</router-link>
        </div>
        <div v-if="isAdmin" class="estimate-menu-item">
          <h3>見積書を承認</h3>
          <router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'EstimateApprovalPendingList' }">承認待ち一覧</router-link>
        </div>
      </div>
    </div>

    <!-- 年間予定作業フロー -->
    <div class="workflow-section bg-annual-work">
      <h2>年間予定作業</h2>
      <div class="workflow">
        <div class="workflow-item">
          <h3>年間予定作業作成</h3>
          <div class="item-block"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'CustomerBuildingList' }">建物情報一覧</router-link></div>
        </div>
        <div class="workflow-arrow">→</div>
        <div class="workflow-item">
          <h3>業者予定表作成</h3>
          <div class="item-block"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'MonthlyWorkVendorList' }">業者別作業予定表</router-link></div>
          <span class="text-danger">※外部発注しない場合は不要</span>
        </div>
        <div class="workflow-arrow">→</div>
        <div class="workflow-item">
          <h3>顧客予定表作成</h3>
          <div class="item-block"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'NonCreateCalendarBuildingList' }">顧客用予定表</router-link></div>
        </div>
        <div class="workflow-arrow">→</div>
        <div class="workflow-item">
          <h3>請求書発行（共通）</h3>
          <div class="item-block"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'NonBillingList' }">請求発行</router-link></div>
        </div>
      </div>
    </div>

    <!-- 臨時作業フロー -->
    <div class="workflow-section bg-temporary-work">
      <h2>臨時作業</h2>
      <div class="workflow">
        <div class="workflow-item">
          <h3>臨時作業作成</h3>
          <router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'TemporaryWorkList' }">臨時作業一覧</router-link>
        </div>
        <div class="workflow-arrow">→</div>
        <div class="workflow-item">
          <h3>請求書発行（共通）</h3>
          <router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'NonBillingList' }">請求発行</router-link>
        </div>
      </div>
    </div>

    <div class="under-menu">
      <!-- マスタ管理 -->
      <div class="home-menu-box bg-master-mng">
        <h2>マスタ管理</h2>
        <div class="menu-items">
          <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'CustomerList' }">顧客マスタ情報</router-link></div>
          <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'CustomerRepresentativeList' }">顧客担当者マスタ情報</router-link></div>
          <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'BuildingTypeList' }">建物種別マスタ情報</router-link></div>
          <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'BuildingList' }">建物マスタ情報</router-link></div>
          <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'VendorList' }">業者マスタ情報</router-link></div>
          <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'BusinessClassificationList' }">業務区分マスタ情報</router-link></div>
          <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'UserList' }">ユーザマスタ情報</router-link></div>
        </div>
      </div>

      <!-- 集計情報管理 -->
      <div v-if="isAdmin" class="home-menu-box bg-aggregate-mng">
        <h2>集計情報管理</h2>
        <div class="menu-items">
          <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'SalesByData' }">年間予定作業 売上集計</router-link></div>
          <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'TemporaryWorkSalesByData' }">臨時作業 売上集計</router-link></div>
          <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'TotalSalesByData' }">全作業 売上集計</router-link></div>
        </div>
      </div>

      <!-- 確認情報 -->
      <div v-if="isAdmin" class="home-menu-box bg-customer-balance">
        <h2>確認情報</h2>
        <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'MonthlyAnnualWorkScheduleList' }">月間作業予定</router-link></div>
        <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'CustomerMoneyConditions' }">顧客金額情報</router-link></div>
        <div class="item-block mb-3"><router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'VendorWorkHistory' }">業者作業履歴集計</router-link></div>
      </div>

      <!-- システム運用 -->
      <div v-if="isSeedSystemAdmin" class="home-menu-box bg-system-operation">
        <h2>システム運用</h2>
        <div class="item-block mb-3">
          <router-link class="memu-item" v-if="isLoggedIn" :to="{ name: 'CustomerPaymentConfirmReset' }">入金確認データリセット</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { isEstimateWriterRole } from '@/utils/estimates';
import { SHOW_ESTIMATE_MENU } from '@/config/navigation';

export default {
  name: "HomeView",
  setup() {
    const title = ref('ホーム');
    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const isAdmin = ref(false);

    const isLoggedIn = computed(() => store.state.isLoggedIn);
    const userRole = computed(() => store.state.userRole);
    const canCreateEstimate = computed(() => isEstimateWriterRole(userRole.value));
    const isSeedSystemAdmin = computed(() => {
      return isLoggedIn.value &&
        String(userRole.value) === '999' &&
        localStorage.getItem('uid') === 'admin@example.com';
    });
    watch(userRole, (newRole) => {
      const normalizedRole = String(newRole);
      isAdmin.value = normalizedRole === "999" || normalizedRole === "0";
    }, { immediate: true });

    return {
      showEstimateMenu: SHOW_ESTIMATE_MENU,
      title,
      isLoggedIn,
      isAdmin,
      canCreateEstimate,
      isSeedSystemAdmin,
    };
  }
};
</script>

<style scoped>
.home-menu {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 20px;
}

.workflow-section h2,
.home-menu-box h2{
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 12px;
}

.workflow-section, .menu-section {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
}

.workflow {
  display: flex;
  align-items: center;
  gap: 10px;
}

.estimate-menu-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
}

.estimate-menu-item {
  min-width: 0;
  padding: 18px 12px;
  border: 1px solid #d5dde4;
  border-radius: 8px;
  background: #fff;
  text-align: center;
}

.estimate-menu-item h3 {
  min-height: 1.5em;
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: bold;
}

.workflow-item h3{
  font-size: 20px;
  font-weight: bold;
}

.workflow-item {
  text-align: center;
  flex: 1;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  padding: 20px 12px;
  border-radius: 8px;
  max-width: 22% !important;
  height: 140px;
}

.workflow-arrow {
  font-size: 24px;
  font-weight: bold;
  color: #555;
}

.under-menu{
  display: flex;
  justify-content: space-between;
  align-items: flex-start; /* これにより、アイテムが上揃えになる */
  gap: 20px;
  flex-wrap: wrap;
  width: 100%;
  /* height: calc(100% - 100px); */
  margin: auto;
}

.under-menu .home-menu-box {
  display: flex;
  flex-direction: column; /* 縦並びにする */
  justify-content: flex-start; /* コンテンツを上揃えにする */
  width: calc((100% / 4) - 16px);
  min-width: 260px;
  height: 100%;
  border: 1px solid #cccccc; /* 軽い境界線 */
  border-radius: 10px;
  padding: 20px 20px 0 20px;
  text-align: center;
  transition: transform 0.3s ease;
  box-sizing: border-box; /* パディングとボーダーをwidthに含める */
}

.memu-item {
  display: inline-block;
  width: 80%;
  max-width: 240px;
  background: #2f4e6d;
  color: white;
  font-size: 16px;
  padding: 10px 0;
  border-radius: 5px;
  text-decoration: none;
}

.memu-item:hover {
  background: #3c658a;
}

.bg-annual-work{
  background-color: #E6FFE9;
}
.bg-estimate-work{
  background-color: #e5f2ff;
}
.bg-temporary-work{
  background-color: #F3FFD8;
}
.bg-master-mng{
  background-color: #D9E5FF;
}
.bg-aggregate-mng{
  background-color: #EAD9FF;
}
.bg-customer-balance{
  background-color: #FFDBC9;
}

.bg-system-operation{
  background-color: #E8EDF3;
}

@media (max-width: 1100px) {
  .workflow {
    align-items: stretch;
    flex-wrap: wrap;
  }

  .workflow-item {
    flex: 1 1 260px;
    max-width: none !important;
  }

  .workflow-arrow {
    display: none;
  }

  .under-menu {
    gap: 20px;
    flex-wrap: wrap;
  }

  .under-menu .home-menu-box {
    flex: 1 1 300px;
    width: auto;
  }

  .home-menu .home-menu-box:nth-child(2) {
    margin: 0;
  }
}

@media (max-width: 600px) {
  .home-menu {
    gap: 20px;
    padding: 12px;
  }

  .workflow-section,
  .menu-section {
    padding: 14px;
  }

  .estimate-menu-grid {
    grid-template-columns: 1fr;
  }

  .workflow-item {
    height: auto;
  }
}
</style>
